import * as React from 'react';

import { formatDate, Utils, getQueryString } from '@/utils/app';
import TitleBox from './titleBox';

import './index.less';

const icon1 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/comment_icon.png';
const icon2 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/live@3x.png';
const icon3 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/icon3.png';
const icon4 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/Group230.png';
const icon5 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/not_data.png';

const { handleClickCommenteRep, jumpGameDetail,} = Utils;

function GameReview(props: any) {
  const { commentData = [], iTotal = 0, iHasMore = 0, gameBaseInfo, fromId, handTipsImgVis } = props;
  const isPreview = getQueryString('preview', '');
  const getRep = (obj: any) => {
    // 预览时阻止按钮点击
    if(isPreview != 0) return;
    const newObj = {
      gamename: gameBaseInfo?.gameName,
      gameid: gameBaseInfo?.gameId,
      area: obj?.area,
      position: obj?.index,
    };
    handleClickCommenteRep(newObj);
    jumpGameDetail({ gameId: gameBaseInfo?.gameId, fromId }, handTipsImgVis);
  };

  const titleBoxProps = {
    title: '精彩评论',
    more: iHasMore ? '更多评论' : null,
    jumpMore: () => {
      getRep({ area: 'morecomment' });
      jumpGameDetail({ gameId: gameBaseInfo?.gameId, fromId }, handTipsImgVis);
    },
  };

  return (
    <div className='comment-list-wrapper'>
      <TitleBox {...titleBoxProps} />
      {(commentData || []).map((item: any, i: number) => (
        <div className='c-l-w-wrapper' key={`${item.lCommentId}_${i}`}>
          <img className='l-w-w-por' src={item.sAvatar} alt='' />
          <div className='l-w-w-box'>
            <div className='w-w-b-top'>{item.sNickName}</div>
            <div className='w-w-b-middle'>{item.sContent}</div>
            <div className='w-w-b-footer'>
              <div className='w-b-f-time'>{formatDate(item.lTime * 1000, 'yyyy-MM-dd')}</div>
              <div className='w-b-f-left'>
                <div
                  className='b-f-l-icon'
                  onClick={(event: any) => {
                    event.stopPropagation();
                    event.cancelBubble = true;
                    getRep({ area: 'reply', index: i + 1 });
                  }}>
                  <img src={icon1} alt='' />
                  {item.iSubCommentCount > 9999 ? '9999' : item.iSubCommentCount}
                </div>
                <div
                  className={`b-f-l-icon ${item.iOpt ? 'active' : ''}`}
                  onClick={(event: any) => {
                    event.stopPropagation();
                    event.cancelBubble = true;
                    getRep({ area: 'like', index: i + 1 });
                  }}>
                  <img src={item.iOpt ? icon3 : icon2} alt='' />
                  {item.iLikeCount > 9999 ? '9999' : item.iLikeCount}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      {!(commentData || []).length ? (
        <div className='l-w-not-w'>
          <img src={icon5} alt='' />
          <div className='w-n-w-title'>当前没有评论</div>
          <div className='w-n-w-desc'>留下你的精彩发言吧~</div>
        </div>
      ) : null}
      <div className={`write-comment ${!!(commentData || []).length ? '' : 'back'}`}>
        <div
          className={`w-c-l ${!!(commentData || []).length ? '' : 'back'}`}
          onClick={() => {
            getRep({ area: 'writecomment' });
          }}>
          <img src={icon4} alt='' /> 写评论
        </div>
        {!!(commentData || []).length ? (
          <div
            className='w-c-r'
            onClick={() => {
              getRep({ area: 'allcomment' });
            }}>
						全部评论 ({iTotal > 9999 ? '9999' : iTotal})
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default GameReview;
